import React from 'react'
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa'
import { FooterContainer, FooterLink, FooterLinkItems, FooterLinksContainer, FooterLinksWrapper, FooterLinkTitle, FooterWrap, SocialIconLink, SocialIcons, SocialLogo, SocialMedia, SocialMediaWrap, WebsiteRights } from './FooterElements'
import {animateScroll as scroll} from 'react-scroll'

const Footer = () => {

    const toggleHome= ()=>{
        scroll.scrollToTop()
    }

    return (
        <FooterContainer>

            <FooterWrap>
                <FooterLinksContainer>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle> About us</FooterLinkTitle>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                            
                        </FooterLinkItems>

                        <FooterLinkItems>
                            <FooterLinkTitle> Videos</FooterLinkTitle>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                            
                        </FooterLinkItems>

                    </FooterLinksWrapper>

                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle> Media</FooterLinkTitle>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                                <FooterLink to="/signin"> How it works? </FooterLink>
                            
                        </FooterLinkItems>

                        <FooterLinkItems>
                            <FooterLinkTitle>Social media</FooterLinkTitle>
                                <FooterLink to="/signin"> Instagram </FooterLink>
                                <FooterLink to="/signin"> Facebook </FooterLink>
                                <FooterLink to="/signin"> Youtube </FooterLink>
                                <FooterLink to="/signin"> Twitter </FooterLink>
                            
                        </FooterLinkItems>

                    </FooterLinksWrapper>

                </FooterLinksContainer>

                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialLogo to="/" onClick={toggleHome}>
                            dolla
                        </SocialLogo>
                        <WebsiteRights>
                            dolla todos los derechos reservados 2021
                        </WebsiteRights>
                        <SocialIcons>
                            <SocialIconLink 
                            href="/" 
                            target="_blank"
                            aria-label="Facebook"
                            >
                                <FaFacebook/>
                            </SocialIconLink>

                            <SocialIconLink 
                            href="/" 
                            target="_blank"
                            aria-label="Instagram"
                            >
                                <FaInstagram/>
                            </SocialIconLink>

                            <SocialIconLink 
                            href="/" 
                            target="_blank"
                            aria-label="YouTube"
                            >
                                <FaYoutube/>
                            </SocialIconLink>

                            <SocialIconLink 
                            href="/" 
                            target="_blank"
                            aria-label="Twitter"
                            >
                                <FaTwitter/>
                            </SocialIconLink>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>


        </FooterContainer>
            
       
    )
}

export default Footer
